import { CustomReactSelectOption } from '@components/custom-react-select'

export const filterClientDetailsProductByStatus = <T extends { status: string }>(
  items: T[],
  statuses: CustomReactSelectOption[],
): T[] => items.filter((item: T) => !statuses.length || statuses.some(option => option.value === item.status))
